import { render, staticRenderFns } from "./ModalMessageContents.vue?vue&type=template&id=7d6cc97b&scoped=true"
import script from "./ModalMessageContents.vue?vue&type=script&lang=js"
export * from "./ModalMessageContents.vue?vue&type=script&lang=js"
import style0 from "./ModalMessageContents.vue?vue&type=style&index=0&id=7d6cc97b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6cc97b",
  null
  
)

export default component.exports